<script>
    import Media from './Media.vue';
    export default {
        mixins: [Media],
        props: {
            paths: {
                type: Object,
                required: true
            }
        },
        computed: {
            path() {
                return this.paths[this.media];
            }
        }
    }
</script>